'use client';

import { Brightness4 as DarkIcon, Brightness7 as LightIcon } from '@mui/icons-material';
import { Box, IconButton, MenuItem, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface ThemeToggleItemProps {
  isDarkMode: boolean;
  onToggle: () => void;
}

export const ThemeToggleItem = ({ isDarkMode, onToggle }: ThemeToggleItemProps) => {
  const { t } = useT();
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <MenuItem
      sx={{
        py: 1.25,
        px: 1.5,
        borderRadius: 2,
        mx: 1,
        mb: 1,
        justifyContent: 'space-between',
      }}
      onClick={onToggle}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2" fontWeight={500}>
          {isDarkMode ? t('menu.darkMode') : t('menu.lightMode')}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={handleToggle}
        sx={{
          // Was inconsistent: dark mode already used the theme token, light
          // mode hardcoded amber. Both now follow the CTA accent (blue).
          color: 'primary.main',
          bgcolor: 'background.subtle',
          '&:hover': {
            bgcolor: 'background.paper',
            transform: 'rotate(15deg)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {isDarkMode ? <LightIcon fontSize="small" /> : <DarkIcon fontSize="small" />}
      </IconButton>
    </MenuItem>
  );
};
